import { z } from "zod";
import { isTrainerJobTitle } from "./roleMap";
import {
  STAKEHOLDER_COMMANDER,
  STAKEHOLDER_PUBLIC_OFFICIAL,
  STAKEHOLDER_SCHOOL_REP,
  STAKEHOLDER_TIER_II,
} from "./stakeholderConstants";
import { isLegacyPracticalPhone, LEGACY_PHONE_INVALID_MESSAGE } from "./phoneLegacy";

export function showOrganizationTypeField(stakeholderType: string): boolean {
  return stakeholderType === STAKEHOLDER_PUBLIC_OFFICIAL || stakeholderType === STAKEHOLDER_SCHOOL_REP;
}

export function showOrganizationDepartmentField(
  stakeholderType: string,
  jobTitle?: string | null,
): boolean {
  if (isTrainerJobTitle(jobTitle)) return false;
  return stakeholderType === STAKEHOLDER_COMMANDER || stakeholderType === STAKEHOLDER_TIER_II;
}

/** Organization step fields (parity with buxusweb `OrganizationInfoForm`). */
export function registrationOrganizationStepSchema(
  stakeholderType: string,
  jobTitle?: string | null,
) {
  return z
    .object({
      institution: z.string().trim().min(1, "Organization name is required"),
      organizationType: z.string().optional().default(""),
      department: z.string().optional().default(""),
      institutionPhone: z.string().trim().min(1, "Organization phone is required"),
    })
    .superRefine((v, ctx) => {
      if (showOrganizationTypeField(stakeholderType) && !v.organizationType?.trim()) {
        ctx.addIssue({
          path: ["organizationType"],
          code: "custom",
          message: "Organization type is required",
        });
      }
      if (showOrganizationDepartmentField(stakeholderType, jobTitle) && !v.department?.trim()) {
        ctx.addIssue({
          path: ["department"],
          code: "custom",
          message: "Department is required",
        });
      }
      if (!isLegacyPracticalPhone(v.institutionPhone)) {
        ctx.addIssue({
          path: ["institutionPhone"],
          code: "custom",
          message: LEGACY_PHONE_INVALID_MESSAGE,
        });
      }
    });
}

export const PUBLIC_OFFICIAL_ORG_TYPES = [
  "City",
  "Township",
  "County",
  "Regional",
  "State",
  "Federal",
  "Other",
] as const;

export const SCHOOL_REP_ORG_TYPES = [
  "Pre-school",
  "Elementary",
  "Middle School",
  "High School",
  "Trade",
  "College",
  "Day Care",
  "Other",
] as const;
